<template>
	<div class="outer-page">
		<div v-if="pageDataStatus === 'success' && page"
			 ref="innerPage"
			 class="inner-page">
			<main>
				<DirectusBlocks v-for="block in page.blocks"
								:key="block.id"
								:data="block" />
			</main>
		</div>
		<div v-else>
			<div class="inner-page">
				<main>
					Loading ...
				</main>
			</div>
		</div>
	</div>
</template>

<script setup>
const { directus, readItems } = useDirectus()
const { $bus } = useNuxtApp()
const metaStore = useMetaStore()
const config = useRuntimeConfig()
const route = useRoute()
const slug = computed(() => route.params.pageslug)
const previewStatus = computed(() => route.query?.status || 'published')
const url = route.fullPath

const innerPageRef = useTemplateRef('innerPage')

const { data: pageData, status: pageDataStatus } = await useAsyncData(`${url}`, () => {
	return directus.request(readItems('pages', pageQuery(slug.value, previewStatus.value)))
})

const page = computed(() => {
	if (!pageData.value.length) showError({ statusCode: 404, statusMessage: 'Page Not Found' })
	return pageData.value[0]
})

useSuperSeoMeta(page.value, { ...config, url })

onMounted(() => {
	metaStore.setActivePageColors(page.value)

	useCssAnims(innerPageRef.value)

	$bus.$emit('header-change-color')
	$bus.$emit('page-mounted')
})
</script>

<style lang="scss" scoped>
:deep(.flex-module:first-of-type) {
	margin-top: 35px;

	@include for-devices-above(md) {
		margin-top: 50px;
	}

	@include for-devices-above(xl) {
		margin-top: 100px;
	}

	&.flexible-herotext {
		position: relative;
		margin-top: 0;
		margin-bottom: 0;

		padding-top: calc(20vmin - 1.5rem);
		// padding-bottom: 14vh;

		@include for-devices-above(md) {
			padding-top: calc(15vh - 3rem);
			// padding-bottom: 14vh;
		}
	}
}



:deep(.flex-module:first-of-type.flexible-herotext + .flex-module) {
	margin-top: 0;
}
</style>
